import { render } from "./LoginCallback.vue?vue&type=template&id=5c41619d"
import script from "./LoginCallback.vue?vue&type=script&lang=ts"
export * from "./LoginCallback.vue?vue&type=script&lang=ts"
script.render = render

export default script